import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'caseGroupVendorsearchPipe',
  pure: true
})
export class CaseGroupVendorsearchPipePipe implements PipeTransform {

  transform(codesData: any[], searchTermven: string): any[] {
    if (!codesData || !searchTermven) { return codesData; }
    return codesData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTermven.toLowerCase().trim()) !== -1

    


    );
  }

}
